<template>
  <div>
    <mdb-modal :show="modal" @close="answerYes">
      <mdb-modal-header>
        <mdb-modal-title>{{ name }}</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <slot name="content">
          <span>Sind Sie noch da?</span>
        </slot>
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn
          color="grey lighten-1"
          @click.native="close"
        >
          Nein
          {{ '('+duration+')' }}
        </mdb-btn>
        <mdb-btn color="primary" @click="answerYes">
          Ja
        </mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
  import {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn
  } from 'mdbvue'

  export default {
    name: 'TimerModal',

    components: {
      mdbModal,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter,
      mdbBtn
    },

    props: {
      modalState: {
        type: Boolean,
        default: false,
      },
      duration: {
        type: Number,
        default: 0
      },
      name: {
        type: String,
        default: 'Noch da?'
      }
    },

    data() {
      return {
        modal: false,
      }
    },

    watch: {
      modalState (v) {
        this.modal = v
      },
    },

    methods: {
      close () {
        this.$emit('close')
      },
      answerYes () {
        this.$emit('answerYes')
      }
    }
  }
</script>
